import {
  GETFEEMANAGEMENTLIST_SUCCESS,
  GETFEEMANAGEMENTLIST_FAILED,
  RESET_GETFEEMANAGEMENTLIST,
  LOADING_GETFEEMANAGEMENTLIST,
  NETWORK_ERROR_GETFEEMANAGEMENTLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetFeeManagementList = () => {
  return { type: RESET_GETFEEMANAGEMENTLIST };
};

const getFeeManagementList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETFEEMANAGEMENTLIST });
  await partnerServices
    .post("getFeeManagementList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.status) {
        case 200:
          dispatch(getFeeManagementListsuccess(res.data));
          break;
        default:
          dispatch(getFeeManagementListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETFEEMANAGEMENTLIST, payload: err });
    });
};
function getFeeManagementListsuccess(data) {
  return {
    type: GETFEEMANAGEMENTLIST_SUCCESS,
    payload: data,
  };
}
function getFeeManagementListFailed(data) {
  return {
    type: GETFEEMANAGEMENTLIST_FAILED,
    payload: data,
  };
}

export { resetGetFeeManagementList, getFeeManagementList };
